import { render, staticRenderFns } from "./FAQBasicSetting.vue?vue&type=template&id=710ee764&scoped=true"
import script from "./FAQBasicSetting.vue?vue&type=script&lang=js"
export * from "./FAQBasicSetting.vue?vue&type=script&lang=js"
import style0 from "./FAQBasicSetting.vue?vue&type=style&index=0&id=710ee764&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "710ee764",
  null
  
)

export default component.exports